import { render, staticRenderFns } from "./Abundance.vue?vue&type=template&id=73448698&"
import script from "./Abundance.vue?vue&type=script&lang=js&"
export * from "./Abundance.vue?vue&type=script&lang=js&"
import style0 from "./Abundance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports